import React from "react";

export const shortNames = {
  externalId: <span title="Технический ID">Тех. ID</span>,
} as const;
